import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'delivery-check-panel',
  templateUrl: './delivery-check-panel.component.html',
  styleUrls: ['./delivery-check-panel.component.scss']
})
export class DeliveryCheckPanelComponent extends CustomComponent {
  @Input() cityName: string;
  @Input() countryCode: string;
  @Input() postNumberChecker: (countryCode: string, postNumber: string) => Promise<string>;

  @Output() onPostNumberChosen = new EventEmitter<any>();
  @Output() onDifferentLocationFound = new EventEmitter<any>();
}
